import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaReadme } from "react-icons/fa";
import { Link } from "react-router-dom";
import { get_all_blogs } from "../store/reducers/homeReducer";
import { format } from "date-fns";

const LatestBlogs = () => {
  const dispatch = useDispatch();
  const { allBlogs } = useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_all_blogs());
  }, [dispatch]);
  const favoriteBlogs = allBlogs
    .filter((blog) => blog.type === "favorite")
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 4);

  return (
    <div className="w-[85%] sm:w-[92%] flex flex-wrap mx-auto my-10 pb-10 justify-center text-center">
      <div className="my-5 ">
        <h1 className="gradient-t0 text-[30px] sm:text-[20px] mb-2">
          مقالات مفيدة
        </h1>
        <h2 className="gradient-t1 text-[22px] sm:text-[15px]">
          قم بالاطلاع على أفضل مقالاتنا لمعرفة المزيد عن الطب
        </h2>
      </div>
      <div className="w-full grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2  gap-6 sm:gap-3 mt-5">
        {favoriteBlogs.map((blog, i) => (
          <div
            key={i}
            className="border border-mainColor rounded-2xl sm:rounded-lg group transition-all duration-500 hover:shadow-md hover:-mt-3"
          >
            <Link to={`/blog/${blog.slug}`}>
              <div className="relative flex overflow-hidden justify-center  ">
                <img
                  className="sm:w-full w-full h-[220px] sm:h-[150px] rounded-t-2xl sm:rounded-t-lg object-cover object-center"
                  src={blog.image}
                  alt={blog.name}
                />

                <ul className="flex px-1 bg-mainBg/35 backdrop-blur-sm w-full rounded-t-md hover:rounded-md transition-all duration-700 bottom-0 justify-center items-center gap-2 absolute  group-hover:bottom-3">
                  <div className="w-full h-[38px] cursor-pointe flex justify-center items-center rounded-md hover:bg-mainColor hover:text-white transition-all">
                    <h2
                      className="text-lg sm:text-sm font-semibold"
                      style={{ textShadow: "-2px 2px 2px #00022e43" }}
                    >
                      اقرأ المزيد
                    </h2>
                    <FaReadme className="w-[38px] hover:scale-[1.3] transition-all" />
                  </div>
                </ul>
              </div>
              <div className="py-3  px-2">
                <h2 className="text-md sm:text-sm font-semibold text-center text-[#00b8fb]">
                  {blog.name}
                </h2>
                <p className="text-sm sm:text-xs text-slate-600 mt-2 text-center">
                  {blog.subTitle}
                </p>

                <div className="flex items-end justify-end mt-1">
                  <p className="text-center text-sm sm:text-xs bg-mainColor/30 self-end w-[60px] rounded-t-md">
                    حسب
                  </p>
                </div>
                <p className="text-sm sm:text-xs font-semibold bg-mainColor/30 p-1 rounded-l-md rounded-b-md">
                  By {blog.writtenBy}
                </p>

                <p className="text-sm text-gray-400 text-right">
                  {format(blog.createdAt, "dd-MM-yyyy")}
                </p>
              </div>
            </Link>
          </div>
        ))}
      </div>
      <div className="my-10">
        <Link to={"/blogs"}>
          <button className="main-btn2">تصفح المزيد</button>
        </Link>
      </div>
    </div>
  );
};

export default LatestBlogs;
